import DynamicIframe from './DynamicIframe';

export default {
  name: 'dynamicIframe',
  class: DynamicIframe,
  querySelector: {},
  options: {},
};



// WEBPACK FOOTER //
// ./client/js/components/DynamicIframe/index.js